import axios from "axios";
import { get } from "lodash";
import { FULFILLED, PENDING, REJECTED } from "./action-type.util";

export const ACTION_TYPES = {
  FETCH_BROKER_APPS: "brokerApps/FETCH_APPS",
};

const initialState = {
  brokerApplications: [],
  isLoading: false,
};

export type BrokerAppsState = Readonly<typeof initialState>;

/**
 * Broker Applications Reducer
 */
export default (state: BrokerAppsState = initialState, action): BrokerAppsState => {
  switch (action.type) {
    case PENDING(ACTION_TYPES.FETCH_BROKER_APPS): {
      return {
        ...state,
        isLoading: true,
      };
    }

    case FULFILLED(ACTION_TYPES.FETCH_BROKER_APPS): {
      return {
        ...state,
        brokerApplications: action.payload.data,
        isLoading: false,
      };
    }

    case REJECTED(ACTION_TYPES.FETCH_BROKER_APPS): {
      return {
        ...state,
        isLoading: false,
      };
    }

    default: {
      return {
        ...state,
      };
    }
  }
};

export const fetchBrokerApps = ({ brokerID, page, rows, sort: sortOptions, query }) => {
  const sort = get(sortOptions, "0.0");
  const sortOrder = get(sortOptions, "0.1") ?? query?.sortOrder;
  return {
    type: ACTION_TYPES.FETCH_BROKER_APPS,
    meta: { listOptions: { page, rows, sort, query } },
    payload: axios.get(`/brokers/${brokerID}/applications/`, {
      params: { rows, page, sort, sortOrder, ...query },
    }),
  };
};
